<template>
  <WithReportAssets :asset-type="assetType" :sort-by="'MATERIAL_NAME'">
    <div
      slot-scope="{ reportAssets, areAssignmentsLoading, reportAssetsError }"
    >
      <WithJobInventoryItems
        v-if="shouldUseJobInventory"
        :job-id="getLocationJobId"
      >
        <div
          slot-scope="{
            jobInventoryItems,
            areItemsLoading: areInventoryLoading,
          }"
        >
          <WithAllAssetsOfType
            asset-type="materialpart"
            :additional-filters="filterByJobTypePicklist"
            filter-match-type="or"
          >
            <div slot-scope="{ allAssets, areAssetsLoading }">
              <DailyReportAssignmentCard
                id="material"
                title="Material"
                :assets="reportAssets"
                :asset-type="assetType"
                :loading="
                  areAssignmentsLoading ||
                    areAssetsLoading ||
                    areInventoryLoading
                "
                :error="reportAssetsError"
                :fields="fields"
                :defaults="{
                  assetNameKey: 'MATERIALPART_NAME',
                  picklistKey: 'MATERIAL_NAME',
                  assgntKey: 'MATERIALPART',
                }"
                @reloadCard="reloadCard"
              >
                <template
                  slot-scope="{
                    asset,
                    draft,
                    updateAssetAction,
                    startSaveTimer,
                    pauseSaveTimer,
                  }"
                >
                  <AssignmentMaterial
                    :materials="
                      allAssets.map((m) => {
                        return {
                          ...m,
                          MATERIALPART_NAME: m.MATERIALPART_NAME,
                        }
                      })
                    "
                    :job-inventory-items="jobInventoryItems"
                    :use-job-inventory="true"
                    :asset="asset"
                    :draft="draft"
                    @update="updateAssetAction"
                    @startSaveTimer="startSaveTimer"
                    @picking="pauseSaveTimer"
                    @donePicking="startSaveTimer"
                  />
                </template>
              </DailyReportAssignmentCard>
            </div>
          </WithAllAssetsOfType>
        </div>
      </WithJobInventoryItems>
      <WithAllAssetsOfType
        v-else
        asset-type="materialpart"
        :additional-filters="filterByJobTypePicklist"
        filter-match-type="or"
      >
        <div slot-scope="{ allAssets, areAssetsLoading }">
          <DailyReportAssignmentCard
            id="material"
            title="Material"
            :assets="reportAssets"
            :asset-type="assetType"
            :loading="areAssignmentsLoading || areAssetsLoading"
            :error="reportAssetsError"
            :fields="fields"
            :defaults="{
              assetNameKey: 'MATERIALPART_NAME',
              picklistKey: 'MATERIAL_NAME',
              assgntKey: 'MATERIALPART',
            }"
            @reloadCard="reloadCard"
          >
            <template
              slot-scope="{
                asset,
                draft,
                updateAssetAction,
                startSaveTimer,
                pauseSaveTimer,
              }"
            >
              <AssignmentMaterial
                :materials="
                  allAssets.map((m) => {
                    return {
                      ...m,
                      MATERIALPART_NAME: m.MATERIALPART_NAME,
                    }
                  })
                "
                :asset="asset"
                :draft="draft"
                @update="updateAssetAction"
                @startSaveTimer="startSaveTimer"
                @picking="pauseSaveTimer"
                @donePicking="startSaveTimer"
              />
            </template>
          </DailyReportAssignmentCard>
        </div>
      </WithAllAssetsOfType>
    </div>
  </WithReportAssets>
</template>

<script>
import { AssetTypes, HumanFields, AssetObjectNames } from '@constants/knack'
import WithReportAssets from '@dataProviders/WithReportAssets'
import WithAllAssetsOfType from '@dataProviders/WithAllAssetsOfType'
import WithJobInventoryItems from '@dataProviders/WithJobInventoryItems'
import { mapGetters } from 'vuex'

import DailyReportAssignmentCard from '@dailyReport/DailyReportAssignmentCard'
import AssignmentMaterial from '@dailyReport/AssignmentMaterial'

export default {
  name: 'CardMaterials',
  components: {
    WithReportAssets,
    WithAllAssetsOfType,
    WithJobInventoryItems,
    DailyReportAssignmentCard,
    AssignmentMaterial,
  },
  data() {
    return {
      assetType: AssetTypes.MATERIALS,
    }
  },
  computed: {
    ...mapGetters(['getTheReport', 'getLocationJobId']),
    shouldUseJobInventory() {
      return this.getTheReport?.JOB_ALLOWS_INVENTORY_SWAP === 1
    },
    fields() {
      return [
        {
          title: this.shouldUseJobInventory ? 'Inv. Item' : 'Material/Part',
          required: true,
        },
        { title: 'Unit', class: 'flex-11-print flex-11-sm flex-11-md' },
        { title: 'Notes', class: 'flex-7-print flex-7-sm flex-7-md' },
        {
          title: 'Sent',
          requiredType: 'number',
          class: 'flex-10-print flex-10-sm flex-10-md',
        },
        {
          title: 'Used',
          requiredType: 'number',
          class: 'flex-10-print flex-10-sm flex-10-md',
        },
        {
          title: 'T&M?',
          class: 'flex-10-print flex-10-sm flex-10-md checkbox-col',
        },
        {
          title: 'Special?',
          class: 'flex-10-print flex-10-sm flex-10-md checkbox-col',
        },
      ]
    },
    filterByJobTypePicklist() {
      if (!this.assetType) return []

      let locationJobType = this.getTheReport.JOB_TYPE
      let jobTypeParts = locationJobType.split(', ')
      let jobTypeRules = jobTypeParts.map((jobType) => ({
        field:
          HumanFields[AssetObjectNames[this.assetType]]
            .INCLUDE_IN_JOB_TYPE_PICKLIST,
        operator: 'contains',
        value: jobType,
      }))

      return jobTypeRules
    }, // filterByJobTypePicklist
  },
  methods: {
    reloadCard() {
      let currentAssetType = this.assetType
      this.assetType = ''
      this.$nextTick(() => {
        this.assetType = currentAssetType
      })
    },
  },
}
</script>

<style lang="scss">
.checkbox-col {
  @media print {
    align-items: center;
    flex-shrink: 1 !important;
  }
}
</style>
